import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock, Loader2, AlertCircle } from 'lucide-react';
import Button from '@/components/ui/Button';
import SEO from '@/components/SEO';

const DemoLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate a small delay for better UX
    await new Promise(resolve => setTimeout(resolve, 500));

    // Check credentials
    if (email === 'rachidnassourou@orcsys.fr' && password === 'OrcsysDemo205@!') {
      // Open the demo URL in a new tab
      const demoUrl = 'https://oiko-orcsysdevteam-orcsys.vercel.app?_vercel_share=BOQKThPkUk8ESCCnPqimWA8FBmMSi7Sz';
      window.open(demoUrl, '_blank');
      
      // Close the current tab after a short delay
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      setError('Email ou mot de passe incorrect');
      setIsLoading(false);
    }
  };

  return (
    <>
      <SEO 
        title="Accès Démo | Orcsys"
        description="Accédez à la démo interactive Orcsys"
        type="website"
      />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white flex items-center justify-center py-12 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-200">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orcsys-50 mb-4">
                <Lock className="w-8 h-8 text-orcsys-500" />
              </div>
              <h1 className="text-2xl font-bold text-slate-900 mb-2">
                Accès à la démo
              </h1>
              <p className="text-slate-600">
                Connectez-vous pour accéder à la démo interactive
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700"
                >
                  <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  <p className="text-sm">{error}</p>
                </motion.div>
              )}

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2">
                  Email
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Mail className="h-5 w-5 text-slate-400" />
                  </div>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-200 focus:border-orcsys-500 focus:ring-2 focus:ring-orcsys-100 outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="votre@email.com"
                    required
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-2">
                  Mot de passe
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Lock className="h-5 w-5 text-slate-400" />
                  </div>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-200 focus:border-orcsys-500 focus:ring-2 focus:ring-orcsys-100 outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="••••••••"
                    required
                  />
                </div>
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-full justify-center bg-orcsys-500 hover:bg-orcsys-600 text-white"
                size="lg"
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                    Connexion...
                  </span>
                ) : (
                  'Se connecter'
                )}
              </Button>
            </form>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default DemoLogin;

